import { useState } from 'react';
import { useParams } from 'react-router-dom';

import { initProductIdentitiesAction } from 'containers/Products/Product/store';
import { CRUDTable } from 'components';

import {
  useGetCompanies,
  useGetRequest,
  usePatchRequest,
  usePostRequest,
  useUserRole,
} from 'hooks';

import { AggregatedProductIdentities, AggregatedProductIdentity, AggregatedProductIdentityCreate, AggregatedProductIdentityUpdate } from 'codegen';
import { InitialTableActions } from 'types';

import {
  columns,
  getFormattedProductIdentities,
  handlePatchIdentity,
  handlePostIdentity,
} from './lib';

export const Identities = () => {
  const [identities, setIdentities] = useState<(AggregatedProductIdentity & { id: number })[]>([]);

  const { productId } = useParams();

  const [{ companies }] = useGetCompanies(true);

  const { loading, refresh } = useGetRequest<AggregatedProductIdentities>({
    url: `/products/details/${productId}/identities`,
    options: {
      onSuccess: ({ data }) => {
        if (data.identities) {
          const formattedIds = data.identities.map((identity, index) => getFormattedProductIdentities(({
            ...identity,
            id: index + 1,
          })));

          setIdentities(formattedIds);
          initProductIdentitiesAction(formattedIds);
        }
      },
    },
  });

  const [postIdentities, { loading: postLoading }] = usePostRequest<AggregatedProductIdentity, AggregatedProductIdentityCreate>({
    url: `/products/details/${productId}/identities`,
    options: { onSuccess: refresh },
  });

  const [patchIdentities, { loading: patchLoad }] = usePatchRequest<AggregatedProductIdentity, AggregatedProductIdentityUpdate>({
    url: `/products/details/${productId}/identities`,
    options: { onSuccess: refresh },
  });

  const { isAdmin } = useUserRole();

  return (
    <CRUDTable
      loading={loading || postLoading || patchLoad}
      columns={columns(companies, refresh, patchIdentities)}
      addNewBtn={{ visible: isAdmin }}
      dataSource={identities}
      initialTableActions={isAdmin ? [{ type: InitialTableActions.Edit }] : undefined}
      onPostTableData={handlePostIdentity(postIdentities)}
      onPatchTableData={handlePatchIdentity(patchIdentities, identities)}
    />
  );
};
